import { Box, TextField as MUITextField, Popper, styled } from "@mui/material";
import { generateFormFieldStyles } from "components/helpers";
import { gray } from "configs/colors";
import { shadows } from "configs/shadows";

export const Container = styled(Box)(({ theme }) => ({
  display: "block",

  // Input Label
  "& > .MuiFormLabel-root": {
    marginBottom: "6px",
  },

  // Helper text
  ".MuiFormHelperText-root": {
    marginTop: "6px",
    "&, &.Mui-disabled": {
      color: gray[600],
    },
    "&.Mui-error": {
      color: theme.palette.error.main,
    },
  },

  ".MuiAutocomplete-endAdornment": {
    top: "50%",
    transform: "translateY(-50%)",
  },
}));

export const StyledPopper = styled(Popper)({
  ".MuiAutocomplete-paper": {
    boxShadow: shadows.lg,
    ".MuiAutocomplete-listbox": {
      padding: "4px 6px",
      ".MuiAutocomplete-option": {
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px 8px",
        borderRadius: "6px",
        "&:hover": {
          backgroundColor: gray[50],
        },
        '&[aria-selected="true"]': {
          backgroundColor: `${gray[50]} !important`,
          "&:hover": { backgroundColor: `${gray[50]} !important` },
        },
      },
      ".MuiAutocomplete-option + .MuiAutocomplete-option": {
        marginTop: "4px",
      },
    },
  },
});

export const SelectedIconWrapper = styled(Box)(() => ({
  display: "inline-flex",
  justifyContent: "center",
  alignItems: "center",
  marginLeft: "8px",
  marginRight: "2px",
}));

export const Input = styled(MUITextField)(({ theme, color }) => {
  const styles = generateFormFieldStyles({ theme, color });

  return {
    marginTop: 0,
    boxShadow: styles.normal.boxShadow,
    borderRadius: theme.shape.borderRadius,
    ".MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input": {
      padding: "8px 14px !important",
    },
    ".MuiOutlinedInput-root.MuiInputBase-sizeSmall": {
      padding: "0 !important",
    },

    // Input root
    ".MuiInputBase-root": {
      backgroundColor: styles.normal.backgroundColor,
      padding: "8px 14px !important",
    },

    // Autocomplete Clear Icon
    ".MuiAutocomplete-clearIndicator": {
      color: gray[500],
    },

    // Autocomplete Popup Icon
    ".MuiAutocomplete-popupIndicator": {
      color: gray[500],
    },

    // Input element
    ".MuiInputBase-input": {
      padding: "8px 14px",
      height: "20px",
    },

    // Fieldset
    ".MuiOutlinedInput-notchedOutline": {
      borderWidth: "1px !important",
      borderColor: styles.normal.borderColor,
      transition: theme.transitions.create([
        "border-color",
        "background-color",
        "box-shadow",
      ]),
    },

    // Helper text
    ".MuiFormHelperText-root": {
      marginLeft: 0,
      marginRight: 0,
      marginTop: "6px",
      "&, &.Mui-disabled": {
        color: gray[600],
      },
    },

    // Disable
    ".Mui-disabled": {
      "&.MuiInputBase-root": {
        backgroundColor: styles.disabled.backgroundColor,
      },

      "&.MuiInputBase-input": {
        "-webkit-text-fill-color": styles.disabled.color,
      },

      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: `${styles.disabled.borderColor} !important`,
      },
    },

    // Without error
    "&:not(.Mui-error)": {
      // Hover
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: styles.normal.hover.borderColor,
      },
      // Focus
      ".Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: styles.normal.focus.borderColor,
        boxShadow: styles.normal.focus.boxShadow,
      },
    },

    // Error
    ".Mui-error": {
      // Hover
      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: styles.error.hover.borderColor,
      },
      // Focus
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: styles.error.focus.borderColor,
        boxShadow: styles.error.focus.boxShadow,
      },
    },
  };
});
